/*
	Installed from https://reactbits.dev/default/
*/

import React, { useEffect, useState } from 'react';
import './ShinyText.css';

const ShinyText = ({ text, disabled = false, speed = 5, className = '', steps, onDone }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (!steps || steps.length === 0) return;
    if (currentStep >= steps.length) {
      if (onDone) onDone();
      return;
    }
    const timeout = setTimeout(() => {
      setCurrentStep((prev) => prev + 1);
    }, steps[currentStep].duration);
    return () => clearTimeout(timeout);
  }, [steps, currentStep, onDone]);

  if (steps && steps.length > 0 && currentStep < steps.length) {
    return (
      <div
        className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
        style={{ animationDuration: `${speed}s` }}
      >
        {steps[currentStep].text}
      </div>
    );
  }

  return (
    <div
      className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
      style={{ animationDuration: `${speed}s` }}
    >
      {text}
    </div>
  );
};

export default ShinyText;
